const GET_BREADCRUMBS_LIST = "GET_BREADCRUMBS_LIST";
const GET_DATA_LIST = "GET_DATA_LIST";
const GET_TABLE_HEADER_LIST = "GET_TABLE_HEADER_LIST";
const GET_USER_NAME = "GET_USER_NAME";
const GET_USER_ID = "GET_USER_ID";
const GET_USER_LOGO = "GET_USER_LOGO";
const GET_ENTITY_ID = "GET_ENTITY_ID";
const GET_NOTIFICATION = "GET_NOTIFICATION";
const GET_CONNECTION = "GET_CONNECTION";
const GET_EMAIL = "GET_EMAIL";
const GET_USER_ROLE = "GET_USER_ROLE";
const GET_NEW_CONTACT_EMAIL = "GET_NEW_CONTACT_EMAIL";
const GET_PROJECT_CLONE = "GET_PROJECT_CLONE";

export function parseBreadcrumbsList(breadcrumbsList) {
    return {
        type: GET_BREADCRUMBS_LIST,
        breadcrumbsList
    }
}

export function parseDataList(dataList) {
    return {
        type: GET_DATA_LIST,
        dataList
    }
}

export function parseTableHeaders(headerList) {
    return {
        type: GET_TABLE_HEADER_LIST,
        headerList
    }
}
export function parseUserName(name) {
    return {
        type: GET_USER_NAME,
        name
    }
}
export function parseUserId(id) {
    return {
        type: GET_USER_ID,
        id
    }
}
export function parseUserlogo(url) {
    return {
        type: GET_USER_LOGO,
        url
    }
}
export function parseUserRole(role) {
    return {
        type: GET_USER_ROLE,
        role
    }
}
export function parseEntityId(id) {
    return {
        type: GET_ENTITY_ID,
        id
    }
}

export function parseNotification(notification) {
    return {
        type: GET_NOTIFICATION,
        notification
    }
}

export function parseConnection(connection) {
    return {
        type: GET_CONNECTION,
        connection
    }
}

export function parseEmail(email) {
    return {
        type: GET_EMAIL,
        email
    }
}
export function parseNewContactEmail(contactEmail) {
    return {
        type: GET_NEW_CONTACT_EMAIL,
        contactEmail
    }
}
export function parseCloneProject(isProjectCloned) {
    return {
        type: GET_PROJECT_CLONE,
        isProjectCloned
    }
}
